import styled from 'styled-components'

const Logo = styled.img`
  text-align: center;
  display: block;
`;

export default Logo;
